
import Sidebar from "../../../components/sidebar/Sidebar";
import Navbar from "../../../components/navbar/Navbar";
import AddClinics from "./AddClinics";

const ViewClinic = () => {
  return (
    <div className="list">
      <Sidebar />
      <div className="listContainer">
        <Navbar />
        <AddClinics />
      </div>
    </div>
  );
};

export default ViewClinic;
